import React from "react";
import ServiceReport from "./ServiceReport";
import {useAxiosSetup} from "../Api";

function Home(props) {
    const [data, setData] = React.useState();
    const api = useAxiosSetup();

    React.useEffect(() => {
        get_data()
    }, [])

    function get_data() {
        api.get('/service_case/service_cases/get_service_statistics/?format=json', ).then((response) => {
            const new_data = response.data
            setData(new_data)
        })
    }


    return (
        <>
            <ServiceReport data={data}/>
        </>
    )
}

export default Home
